import { DefaultButton } from 'components/index'
import { UserContext } from 'context/userContext'
import { numberToMoney } from 'helper/utils'
import { useContext, useState } from 'react'

import { FeedbackIcon } from 'components/PinConfirmation/style'
import { Icon } from 'assets/index'
import useSocket from 'hooks/useSocket'
import { Container } from './style'

const ResumoDepositar = () => {
  const { resumoDepo, setPage, setShowModal } = useContext(UserContext)
  const [buttonText, setButtonText] = useState('Copiar código')
  const [gotDeposit, setGotDeposit] = useState(false)

  useSocket((socket) => {
    if (socket) {
      socket.on('deposit_done', async () => {
        setGotDeposit(true)
        setTimeout(() => {
          setGotDeposit(false)
          setPage(0)
          setShowModal(false)
        }, 3000)
      })
    }
  })
  return (
    <Container>
      {gotDeposit ? (
        <div className="depositar-feedback-container">
          <div className="feedback-column">
            <img
              className="feedback-icon"
              src={Icon('check_circle.svg')}
              alt="feedback"
            />
            <p>Depósito realizado</p>
          </div>
        </div>
      ) : (
        <div className="depositar-pix-info-container">
          <p>
            <span className="depositar-text1">Utilize</span>
            <span className="depositar-text2">QR Code ou Chave PIX</span>
            <span className="depositar-text1">para realizar o depósito</span>
          </p>
          <span className="depositar-valor">{`R$ ${numberToMoney(
            resumoDepo?.depositValue
          )}`}</span>
          <img
            className="depositar-qrcode"
            src={`data:image/png;base64, ${resumoDepo?.encodedImage}`}
            alt="qrcode"
          />
          <p className="depositar-codigoPix">{resumoDepo?.payload}</p>
          <DefaultButton
            onClick={() => {
              if (resumoDepo?.payload) {
                navigator.clipboard.writeText(resumoDepo.payload)
                setButtonText('Código copiado!')
                setTimeout(() => {
                  setButtonText('Copiar código')
                }, 3000)
              }
            }}
          >
            {buttonText}
          </DefaultButton>
        </div>
      )}
    </Container>
  )
}

export default ResumoDepositar
